import React, { useState } from 'react';
import './AdminAuth.css';
import apiClient from '../../services/apiClient';

const AdminAuth = ({ onAuthenticated }) => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      console.log('🔐 Attempting SQLite backend authentication...');
      const response = await apiClient.login(credentials);
      
      if (response.success) {
        console.log('✅ SQLite backend authentication successful');
        console.log('🔐 Token received and stored for API calls');
        onAuthenticated('backend');
        return;
      } else {
        throw new Error(response.message || 'Login failed');
      }
    } catch (error) {
      console.error('Authentication error:', error);
      setError(error.message || 'Authentication failed');
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (field, value) => {
    setCredentials(prev => ({ ...prev, [field]: value }));
    if (error) setError('');
  };

  return (
    <div className="admin-auth">
      <div className="auth-container">
        <div className="auth-header">
          <div className="auth-logo">
            <i className="fas fa-shield-alt"></i>
          </div>
          <h1>DentoXcellence CMS</h1>
          <p>Content Management System</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">

          <div className="form-group">
            <label htmlFor="username">
              <i className="fas fa-user"></i>
              Username
            </label>
            <input
              type="text"
              id="username"
              value={credentials.username}
              onChange={(e) => handleInputChange('username', e.target.value)}
              required
              placeholder="Enter your username"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">
              <i className="fas fa-lock"></i>
              Password
            </label>
            <input
              type="password"
              id="password"
              value={credentials.password}
              onChange={(e) => handleInputChange('password', e.target.value)}
              required
              placeholder="Enter your password"
            />
          </div>

          {error && (
            <div className="error-message">
              <i className="fas fa-exclamation-triangle"></i>
              {error}
            </div>
          )}

          <button 
            type="submit" 
            className={`login-btn ${isLoading ? 'loading' : ''}`}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <i className="fas fa-spinner fa-spin"></i>
                Authenticating...
              </>
            ) : (
              <>
                <i className="fas fa-sign-in-alt"></i>
                Login to CMS
              </>
            )}
          </button>
        </form>


        <div className="auth-footer">
          <a href="/" className="back-to-site">
            <i className="fas fa-arrow-left"></i>
            Back to Website
          </a>
        </div>
      </div>
    </div>
  );
};

export default AdminAuth;
